export default {
  // base_url: "http://192.168.25.20:8000/api/",
  // base_url: "http://3.85.70.152:8000/api/"
  // base_url: "http://192.168.1.172:8000/api/",
  // base_url: "https://coupon-generator-backend-68wgj.ondigitalocean.app/api/",
  base_url: "https://apigch.souenergy.com.br/api/"
  // base_url: "http://localhost:8000/api/",
};
